/*
*   This Component Catches and Handles Render Errors, Wrap all UI Parent Components with this.
*   Handles Ajax Requests for the Child Component so that it can cancel the request when the component unmounts
*
*/

import React from 'react'
import {Chip} from 'react-md'
import axios from 'axios'
import { AppProperties, AppSetting } from '../common/functions';
import globalLog from './globalLog';
import { GlobalContext } from '../GlobalContext';
import ErrorBoundary from '../pages/ErrorBoundary';

var zoomListeners = [];

(function(){
  // Poll the pixel width of the window; invoke zoom listeners
  // if the width has been changed.
  var lastWidth = 0;
  function pollZoomFireEvent() {
    var widthNow = window.innerWidth;
    if (lastWidth == widthNow) return;
    lastWidth = widthNow;
    // Length changed, user must have zoomed, invoke listeners.
    for (let i = zoomListeners.length - 1; i >= 0; --i) {
      zoomListeners[i]();
    }
  }
  setInterval(pollZoomFireEvent, 100);
})();


function ESComponentWrapper(WrappedComponent,handleRoute,updateQuizURL) {

    return class extends React.Component{

        appProperties = AppProperties();
        appSetting = AppSetting();
        strDefaultErrorMessage = 'Something went wrong, please see technical troubleshooting page for intructions';
        strErrorMessage = this.strDefaultErrorMessage;

        constructor(props) {
            super(props)
            this.cancelTokens = [];
            this.makeAjaxRequest = this.makeAjaxRequest.bind(this);

            this.state = {
               appStates: [],
               isError:false,
               mailWhiteList:[]
            }
          }

          onRoute(url)
          {
              handleRoute(url);
          }

          getWhiteListFromServer() {
            let newURL = this.appProperties.baseURL + '/whitelist'
            fetch(newURL, {
              method: 'get',
              headers: {
                'Authorization': 'Token ' + this.appProperties.currentUserData.token,
                'Content-Type': 'application/json'
              },
            })
            .then(response => response.json())
            .then(res => {

              this.setState({
                mailWhiteList: res?.data
              })

            })
            .catch(error => {
              console.error(error)
            });
          }
          getLTIUserDetails() {
            const queryParams = new URLSearchParams(window.location.search);
            let token = queryParams.get('token')
            let ltiUserID = queryParams.get('ltiUserID')
            if (token && ltiUserID && token !== "" && ltiUserID !== "" ) {
              const [encodedHeader, encodedPayload, signature] = token.split('.');
              let decodedPayload;
              try {
                  decodedPayload = JSON.parse(atob(encodedPayload));
              } catch (error) {
                console.error(error)
                return
              }
              if (decodedPayload) {
                //logout existing user
                if (this.appProperties.enableLogin) {
                    window.localStorage.setItem(this.appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'token', '');
                    window.localStorage.setItem(this.appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'GivenName', '');
                    window.localStorage.setItem(this.appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'USER_NAME', '');
                    window.localStorage.setItem(this.appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'UnixEpoch', '');
                    window.localStorage.setItem(this.appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'emailid', '');
                    window.localStorage.setItem(this.appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'OSUID', '');
                    window.localStorage.setItem(this.appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'role', '');
                    window.localStorage.setItem('isLTIStudent', '');
                }
                let exisitingUser = this.appProperties?.currentUserData?.USER_NAME
                if (exisitingUser && exisitingUser !== "" && decodedPayload?.USER_NAME && decodedPayload?.USER_NAME !== "" &&  exisitingUser !== decodedPayload?.USER_NAME) {
                  window.localStorage.setItem("isLTIStudent", decodedPayload.isLTIStudent);
                  this.appProperties.currentUserData.setUserDetails(decodedPayload, this.appProperties.loginType);

                  // Remove the token once it's been used
                  if (queryParams.has('token')) {
                    queryParams.delete('token');
                    const newSearch = queryParams.toString();
                    const newPath = `${window.location.pathname}?${newSearch}`;

                    const encodedPath = encodeURI(newPath);

                    console.debug("encodedPath", encodedPath)

                    window.history.replaceState(null, '', encodedPath);
                    window.location.reload();
                }
                }
             }
            }
          }

          sendLogs(payload) {
            let newURL = this.appProperties.baseURL + '/addClientLog'
            fetch(newURL, {
              method: 'POST',
              headers: {
                'Authorization': 'Token ' + this.appProperties.currentUserData.token,
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(payload)
            })
            .then(response => response.json())
            .then(data => {
              console.debug("data", data);
              // Set the globalLog value to empty string
              globalLog.value = '';
            })
            .catch(error => {
              console.error(error)
              // Set the globalLog value to empty string
              globalLog.value = '';
            });
          }

          saveLogsToFile() {
            const file = new File([globalLog.value], `console_log_${new Date()}`, { type: 'text/plain' });
            const url = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'console.log';
            link.click();
          }

          getStringifyData(data) {
            let dataStr = '';
            try {
                dataStr = JSON.stringify(data)
            } catch (error) {
               console.debug("error", error)
            }
            return dataStr
          }

          makeAjaxRequest(requestData)
          {

            //url,method,payload
            let CancelToken = axios.CancelToken;
            let source      = CancelToken.source();
            this.cancelTokens.push(source);

            let newURL = this.appProperties.baseURL+requestData.url

            axios.interceptors.request.use((request) => {
                request.headers['Authorization'] = 'Token '+this.appProperties.currentUserData.token;
                request.headers['content-type'] =  'application/json';

                return request;
           }, () => {

          });


            return new Promise((resolve,reject) =>{
                axios({
                method: requestData.method,
                url: newURL,
                data:requestData.data,
                cancelToken:source.token
              }).then((res) => {

                // Check if response status is 1; 1 = FAIL, 0 = SUCCESS
                // If status is 1 then send all the logs to DB
                if (res && res.data && res.data.status && res.data.status === 1) {
                  let payload = {
                    quiz_id: requestData.data && requestData.data.quiz_id ? requestData.data.quiz_id : -1,
                    log_time: new Date(),
                    error_log: this.getStringifyData(res),
                    console_log: globalLog.value,
                    gnb_arr: this.getStringifyData(window.localStorage.getItem('gnbArr')),
                  }
                  this.sendLogs(payload)
                } else {
                  // If API call is success, then set globalLog value to empty string
                  globalLog.value = ''
                }
                return resolve(res);
               }).catch((error) => {
                if (axios.isCancel(error)) {
                    console.debug('Request canceled', error.message);
                  } else {
                    //console.debug('error.message',JSON.stringify(error.response.data));

                    if(error !== undefined && error.message !== undefined && requestData.skipErrorHandle !== true)
                    {

                      // Payload for sending logs
                      let payload = {
                        quiz_id: requestData.data && requestData.data.quiz_id ? requestData.data.quiz_id : -1,
                        log_time: new Date(),
                        error_log: this.getStringifyData(error),
                        console_log: globalLog.value,
                        gnb_arr: this.getStringifyData(window.localStorage.getItem('gnbArr'))
                      }

                      this.sendLogs(payload);
                      // this.saveLogsToFile();

                        switch(error.message)
                        {
                            case 'Network Error':
                                this.strErrorMessage = 'Unable to Connect to Server. Try refreshing the website.'
                                break;
                            case 'Request failed with status code 401':
                                this.strErrorMessage = 'Your Session with OSU has Expired,Redirecting to OSU Login';
                                console.debug("Shibboleth Details could have Expored, Clearing Session Data and Redirecting to Login");
                                this.appProperties.currentUserData.clearSessionData();
                                window.location.replace(this.appProperties.appURL);
                                break;
                            case 'Request failed with status code 403':
                                this.strErrorMessage = 'Sorry, your session has expired. Please logout and start the assignment again from Carmen.\n To logout, please click on the "Logout" button located in the left menu.';
                                this.appProperties.currentUserData.clearSessionData();
                                break;
                            default:
                                this.strErrorMessage = this.strDefaultErrorMessage;
                                break;

                        }
                          this.setState({isError:true});
                    }
                    return reject(error)
                  }

                })
              });

          }

          updateAppState = (newValue) => {
            this.setState({
              appStates: this.state.appStates && this.state.appStates.length < 10 ? [...this.state.appStates, newValue] : [newValue]
            })
        }
        

          componentDidMount()
          {
            this.getWhiteListFromServer()
            this.getLTIUserDetails()

          }

          subscribeToZoomEvent(listener){
            if(listener){
                zoomListeners.push(listener);
            }
          }

          cancelAllAjaxRequests()
          {
            if(this.cancelTokens !=null)
                this.cancelTokens.forEach(source => {
                    source.cancel("Component UnMounted");
                });
          }

          componentWillUnmount()
          {
            console.debug("Component WillUnmount");
            this.cancelAllAjaxRequests();


          }


          shouldComponentUpdate(nextProps)
          {
              console.debug("shouldComponentUpdate");
              return true;
          }
          componentDidUpdate(nextProps)
          {
              console.debug("componentDidUpdate");
          }


          componentDidCatch(error,info)
          {
              //TODO:Add Error Notification and Send Error to Server for Logging
              console.error("Error Occured");

              //Set Component Error State to True
              this.setState({isError:true});
          }


          render() {
            
              //If there is an Error Display Error Message
              //TODO: Add Meaningful Error Messages
              if(this.state.isError)
                  return <Chip label={this.strErrorMessage} style={{
                    whiteSpace:'pre',
                    height:'fit-content',
                  }} 
                    labelStyle={{
                      padding:"6px 0px"
                    }}
                  />
              return    <GlobalContext.Provider value={{
                appStates: this.state.appStates,
                updateAppState: this.updateAppState,
            }}>
                <ErrorBoundary appStates={this.state.appStates} apiService={this.makeAjaxRequest} {...this.props}>
                  <WrappedComponent whitelist={this.state.mailWhiteList} subscribeToZoomEvent={this.subscribeToZoomEvent}  globalProperties={this.appProperties} handleRoute={handleRoute} data={this.state.data} apiService={this.makeAjaxRequest} updateQuizURL={updateQuizURL} {...this.props} />
                </ErrorBoundary>

              </GlobalContext.Provider>
              {/* return <WrappedComponent subscribeToZoomEvent={this.subscribeToZoomEvent}  globalProperties={this.appProperties} handleRoute={handleRoute} data={this.state.data} apiService={this.makeAjaxRequest} updateQuizURL={updateQuizURL} {...this.props} />; */}

          }
    }

}

export default ESComponentWrapper;
